import Storage from './Storage';

var ES6Promise = require("es6-promise");
ES6Promise.polyfill();

const axios = require("axios");

class Http {

    apiUrl: string = process.env.REACT_APP_API_URL || "";
    storage = new Storage();

    async get(url: string) {
        return await axios.get(`${this.apiUrl}/${url}`, {
            headers: {
                'Content-Type': "application/json"
            }
        });
    }

    async post(url: string, data: any) {
        return await axios.post(`${this.apiUrl}/${url}`, data, {
            headers: {
                'Content-Type': "application/json"
            }
        });
    }

    async secureGet(url: string) {
        return await axios.get(`${this.apiUrl}/${url}`, {
            headers: {
                'Content-Type': "application/json",
                'Authorization': `Bearer ${this.storage.token()}`
            }
        });
    }

    async securePost(url: string, data: any) {
        return await axios.post(`${this.apiUrl}/${url}`, data, {
            headers: {
                'Content-Type': "application/json",
                'Authorization': `Bearer ${this.storage.token()}`
            }
        });
    }
}

export default Http;